
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom"
import { InAppTemplate } from "../../../shared/templates/inapp";
import Rate from "../../../assets/rate.svg";
import { Formik, Form, Field, FormikProps, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import { TableComponent } from "../../../shared/components/table"
import { FilterUtil } from "../../../shared/components/report-filter"
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Modal from 'react-bootstrap/Modal'

import ActionIco from "../../../assets/action.png"
import ReactPaginate from 'react-paginate';

import { AlertMsg } from "../../../shared/components/alert-msg"
import Shop1 from "../../../assets/shop_1.jpeg"
import TrendUp from "../../../assets/trend_up.svg"
import ShopIco from "../../../assets/shop_ico.svg"
import CheckIco from "../../../assets/check_n.svg"
import CancelIco from "../../../assets/cancel.svg"


import { appActions } from "../../../redux/actions/in-app"
import { LoadingItem } from "../../../shared/components/loading"
import { appConstants } from "../../../redux/action-constants/inapp.constants";

import { formatAddress, getDateFromISO } from "../../../shared/utils"

import { history } from "../../../shared/_helpers/history";


import { useWindowSize } from "../../../hooks/useWindowSize";

import "../index.scss"
import CustomPagination from '../../../shared/components/pagination/CustomPagination';


const getStoresList = async ({ pageProps, payload }: any) => {

    await pageProps.getStoresAction(payload);
}

const toggleStoreAction = async ({ pageProps, payload, action }: any) => {

    await pageProps.toggleStoreAction(payload, action);
}

const SuspendStoreModal = (props: any) => {
    let { showSuspendModal, setShowSuspendModal, pageProps, storeId, storeName } = props;

    // let checkValidationSchema = Yup.object().shape({
    //     reason: Yup.string().trim()
    //         .required('Required'),

    // });

    const suspendProcess: any = (payload: any) => {
        toggleStoreAction({
            pageProps,
            payload,
            action: "activate"
        }).then(() => {
        })
    }

    return (
        <Modal className="suspend_wrap" show={showSuspendModal} onHide={() => {
            if (!pageProps?.toggleStoreRequest?.is_request_processing) {
                setShowSuspendModal(false)
            }
        }
        }>
            <Modal.Header closeButton>
                Activate {storeName}?
            </Modal.Header>
            <Modal.Body>
                {pageProps?.toggleStoreRequest?.request_status !== appConstants.TOGGLE_STORE_SUCCESS &&
                    <>
                        <div className="head_message">
                            Please be advised that activating this store will  means that <span> customers will now be able to make purchases from this store</span>. <br /> Are you sure you want to proceed with this action?
                        </div>
                        <div className="suspend_form">
                            <Formik
                                initialValues={{
                                    reason: ""
                                }}

                                // validationSchema={checkValidationSchema}
                                onSubmit={(values) => {
                                    let { reason } = values;
                                    let payload = {
                                        ids: [
                                            storeId
                                        ],
                                        // reason
                                    }

                                    suspendProcess(payload)




                                }}
                            >
                                {(props: FormikProps<any>) => {
                                    const {
                                        values,
                                        touched,
                                        errors,
                                        // handleBlur,
                                        handleChange,
                                        // isSubmitting,
                                    } = props;

                                    return (
                                        <Form>


                                            {/* {!pageProps.toggleStoreRequest?.is_request_processing &&
                                                <textarea value={values.reason}
                                                    name="reason" id="reason"
                                                    placeholder='Reason for suspension'
                                                    onChange={handleChange('reason')}
                                                    className={` ${errors.reason && touched.reason ?
                                                        "is-invalid-input "
                                                        : !errors.reason && values.reason !== "" ? "valid-input" : ""}`}
                                                    rows={10}></textarea>
                                            } */}
                                            {/* <ErrorMessage name="reason" className="form-input-error" component="div" /> */}
                                            {pageProps?.toggleStoreRequest?.request_status
                                                && pageProps.toggleStoreRequest.request_status === appConstants.TOGGLE_STORE_FAILURE &&
                                                <AlertMsg type="error" message={pageProps.loginRequest?.request_data.error} />
                                            }
                                            <div className="suspend_ctas">
                                                <button className="btn cancel"
                                                    disabled={pageProps.toggleStoreRequest?.is_request_processing}
                                                    onClick={() => setShowSuspendModal(false)}
                                                > Cancel</button>
                                                <button
                                                    type="submit"
                                                    className="btn confirm"
                                                    disabled={pageProps.toggleStoreRequest?.is_request_processing}
                                                >
                                                    {pageProps.toggleStoreRequest.is_request_processing ? "Please wait..." : "Confirm activation"}
                                                </button>
                                            </div>




                                        </Form>
                                    )
                                }}
                            </Formik>
                        </div>
                    </>
                }
                {pageProps?.toggleStoreRequest?.request_status === appConstants.TOGGLE_STORE_SUCCESS &&
                    <AlertMsg type="success" message="Store was successfully activated" />
                }
            </Modal.Body>
        </Modal>
    )

}




const InAppContent = ({ pageProps }: any) => {

    const location = useLocation();
    const navigate = useNavigate();

    const queryParams = new URLSearchParams(location.search);
    const initialPage = parseInt(queryParams.get("page") as string) || 1;

    const [pageNumber, setPageNumber] = useState(initialPage);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        params.set("page", pageNumber.toString());
        navigate(`?${params.toString()}`, { replace: true });
    }, [pageNumber, location.search, navigate]);

    const [pageSize, setPageSize] = useState(10);
    const screenResolution: any = useWindowSize();
    const [showSuspendModal, setShowSuspendModal] = useState<boolean>(false);

    const [actionTodo, setActionTodo] = useState<any>()
    const [storeId, setStoreId] = useState<any>()
    const [storeName, setStoreName] = useState<any>()

    useEffect(() => {

        getStoresList({
            pageProps,
            payload: "CLEAR"
        })
        getStoresList({
            pageProps,
            payload: `?Page=${pageNumber}&Size=${pageSize}&IsActive=${false}`
        })

    }, [])

    useEffect(() => {

        getStoresList({
            pageProps,
            payload: `?Page=${pageNumber}&Size=${pageSize}&IsActive=${false}`
        })

    }, [pageNumber, pageSize])
    const handlePageClick = (event: any) => {

        setPageNumber(event?.selected + 1)

    }
    const loadNextPage = (nextPage: any, tempData: any) => {
        // const { dispatch } = this.props;
        // let { PageSize } = this.state;



        setPageNumber(nextPage)
    };

    const ReportTable = () => {
        let storesList = pageProps.getStoresListRequest?.request_data?.response?.data;
        let activeStores: any[] = storesList?.results;
        // let activeStores = allStores.filter((eachStore: any) => eachStore?.isActive === true);
        return (
            <>
                <thead>
                    <tr>
                        <th className="left_top"> <span >Store</span> </th>
                        <th> Address</th>
                        {/* <th>Total sales</th> */}
                        <th>Store reviews</th>
                        <th>Created on</th>
                        <th className="right_top"> <span>Store information</span> </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        activeStores.map((eachStore: any, index: any) => {
                            let negativeFeedbackCount: any = 0,

                                positiveFeedbackCount: any = 0,

                                neutralFeedbackCount: any = 0,

                                totalReviewsCount: any = 0;
                            // console.log("eachStore", eachStore)
                            let allRatings: any[] = eachStore?.ratings || [];

                            allRatings.forEach((eachRating: any) => {

                                if (eachRating >= 4) {
                                    positiveFeedbackCount += 1
                                }
                                if (eachRating === 3) {
                                    neutralFeedbackCount += 1
                                }
                                if (eachRating < 3) {
                                    negativeFeedbackCount += 1
                                }


                            })
                            return (
                                <tr key={index}>

                                    <td className="brand_name"> <div className="brand_info"> <input type="checkbox" name="" id="" /> <img src={Shop1} alt="" /></div> {eachStore?.name}</td>
                                    <td className="grayed">{formatAddress(eachStore?.address)}</td>
                                    {/* <td className="branded">$54,972</td> */}
                                    <td> <span className="postive review_count">{positiveFeedbackCount} - </span>  <span className="neutral review_count">{neutralFeedbackCount} - </span><span className="negative review_count">{negativeFeedbackCount}</span></td>
                                    <td className="grayed">{eachStore.dateCreated ? getDateFromISO({ date: eachStore.dateCreated, returnTime: true }) : "N/A"}</td>
                                    <td className="branded more_info">
                                        <div className="inner_td">
                                            <Link to={`/app/stores/${eachStore?.id}/details`}>
                                                <span>Store info <img src={TrendUp} alt="" /> </span>
                                            </Link>

                                            <Dropdown className="report_dropdown" as={ButtonGroup}>
                                                <Dropdown.Toggle id="dropdown-basic" className="action-cta">
                                                    <div className="action">
                                                        <img src={ActionIco} alt="" />
                                                    </div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {/* <Dropdown.Item>
                                                        View details
                                                    </Dropdown.Item> */}
                                                    {!eachStore?.isActive &&
                                                        <>
                                                            <Dropdown.Item className="red_action" onClick={() => {
                                                                toggleStoreAction({
                                                                    pageProps,
                                                                    payload: "CLEAR",
                                                                    action: "activate"
                                                                })
                                                                setStoreId(eachStore?.id)
                                                                setStoreName(eachStore?.name)
                                                                // setActionTodo("Activate")
                                                                setShowSuspendModal(true)
                                                            }
                                                            }>
                                                                <img src={CancelIco} alt="" /> Activate
                                                            </Dropdown.Item>
                                                        </>
                                                    }
                                                    {/* {!eachStore?.isActive &&
                                                    <Dropdown.Item>
                                                    Approve Store
                                                    </Dropdown.Item>
                                                } */}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </td>


                                </tr>
                            )
                        })
                    }

                </tbody>
            </>
        )
    }


    const ReportsDisplay = () => {
        let storesList = pageProps.getStoresListRequest?.request_data?.response?.data;
        let allStores: any[] = storesList?.results;

        // let activeStores = allStores.filter((eachStore: any) => eachStore?.isActive === true);


        return (
            <div className="reports_wrap">
                {(showSuspendModal && storeName && storeId) && <SuspendStoreModal storeName={storeName} pageProps={pageProps} storeId={storeId} showSuspendModal={showSuspendModal} setShowSuspendModal={setShowSuspendModal} />}
                <div className="report_head_wrap">
                    <div className="report_head_left">
                        <div className="report_heading">Stores <span>{storesList?.totalNumberOfRecords}</span></div>

                    </div>

                </div>
                <div className="vendor_graphs">
                    <div className="top_of_graph">
                        <div className="left_side">
                            <img src={ShopIco} alt="" />
                            <div className="title_txt">TOP STORES <span>($)</span></div>
                        </div>
                        <div className="right_side">
                            <select name="" id="">
                                <option value="Winnipeg">Winnipeg</option>
                                <option value="Winnipeg">Manitoba</option>
                            </select>
                        </div>
                    </div>
                    <div className="all_graphs">
                        <div className="each_graph">
                            <div className="vendor_name_txt">Food Emporium</div>
                            <div className="sales_bar">
                                <div className="sales_bar_fill" style={{ width: "84%" }}>$15,734</div>

                            </div>
                        </div>
                        <div className="each_graph">
                            <div className="vendor_name_txt">Tasty Treats</div>
                            <div className="sales_bar">
                                <div className="sales_bar_fill" style={{ width: "79%" }}>$11,124</div>
                            </div>
                        </div>
                        <div className="each_graph">
                            <div className="vendor_name_txt">Savory Pantry</div>
                            <div className="sales_bar">
                                <div className="sales_bar_fill" style={{ width: "60%" }}>$8,473</div>
                            </div>
                        </div>
                        <div className="each_graph">
                            <div className="vendor_name_txt">SPAR Markets</div>
                            <div className="sales_bar">
                                <div className="sales_bar_fill" style={{ width: "50%" }}>$5,290</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="table_navs">
                    <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/stores">
                        <div className="table_nav_item">Active stores </div>
                        <div className="underline"></div>
                    </NavLink>
                    <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/stores/unverified">
                        <div className="table_nav_item">Unverified stores </div>
                        <div className="underline"></div>
                    </NavLink>
                    <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/stores/suspended">
                        <div className="table_nav_item">Suspended stores ({storesList?.totalNumberOfRecords})</div>
                        <div className="underline"></div>
                    </NavLink>
                    {/* <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/stores/deleted">
                        <div className="table_nav_item">Deleted stores</div>
                        <div className="underline"></div>
                    </NavLink> */}
                </div>
                <div className="reports_table">
                    <div className="report_actions">
                        <input type="text" className="search_table" placeholder="Search for vendor, store name" />
                        <div className="right_actions">
                            <FilterUtil />
                        </div>
                    </div>
                    {storesList?.results &&
                        <TableComponent
                            isEmptyRecords={!storesList || storesList?.results.length === 0}
                            requestData={storesList}
                            // setPageNumber={()=>setPageNumber()}
                            // refreshFunc={()=>{
                            //     setPageSize()
                            // }}
                            childComponent={<ReportTable />}
                        // childComponent={<ReportTable reportData={pageProps.getStoreOrdersRequest.request_data.response} />}
                        />
                    }
                    {storesList?.totalNumberOfRecords > pageSize &&
                        <CustomPagination
                            pageCount={storesList?.totalNumberOfPages}
                            forcePage={pageNumber - 1}
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={4}
                            renderOnZeroPageCount={null}
                            currentPageNumber={pageNumber}
                        />
                    }
                </div>
            </div>
        )
    }










    // console.log("getDashbardBottompDataRequest", getDashbardBottompDataRequest);
    return (
        <div className="inapp-content">

            <div className="page-content dashboard">
                {pageProps.getStoresListRequest.request_status === appConstants.GET_STORES_LIST_PENDING &&
                    <LoadingItem />
                }
                {pageProps.getStoresListRequest.request_status === appConstants.GET_STORES_LIST_SUCCESS &&
                    <ReportsDisplay />
                }
            </div>
        </div>
    )
}

const SuspendedStoresManagement = (pageProps: any) => {

    return (
        <InAppTemplate pageHeadingTitle="Stores Management" childComponent={<InAppContent pageProps={pageProps} />} />
    )
}


const mapDispatchToProps = {
    getStoresAction: appActions.GetStores,
    toggleStoreAction: appActions.ToggleStore,
};

const mapStateToProps = (state: any) => ({
    getStoresListRequest: state.allInAppReducers.getStoresListReducer,
    toggleStoreRequest: state.allInAppReducers.toggleStoreReducer,
})
export default connect(mapStateToProps, mapDispatchToProps)(SuspendedStoresManagement);